export default __webpack_public_path__ + "static/media/exclametry_bg_red_dark.fb378a70.svg";